// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#chat-sticky {
  height: 100%;
  background-color: white;
  box-shadow: 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 5px 5px -3px rgba(0, 0, 0, 0.2);
}
#chat-sticky .chat-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--primary-color);
  padding: 10px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-sizing: border-box;
  height: 40px;
}
#chat-sticky .chat-header h4 {
  color: white;
}
#chat-sticky .chat-header mat-icon {
  color: white;
}
#chat-sticky .chat-header mat-icon:hover {
  cursor: pointer;
}
#chat-sticky .chat-content {
  height: calc(60vh - 90px);
  overflow: auto;
}
#chat-sticky .chat-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #F5F5F5;
}
#chat-sticky .chat-content::-webkit-scrollbar {
  width: 6px;
  background-color: #F5F5F5;
}
#chat-sticky .chat-content::-webkit-scrollbar-thumb {
  background-color: #404040;
}
#chat-sticky .chat-content .chat-section {
  padding: 10px;
}
#chat-sticky .chat-content .chat-section .day-view {
  margin-bottom: 20px;
}
#chat-sticky .chat-content .chat-section .day-view .date h6 {
  text-align: center;
}
#chat-sticky .chat-content .chat-section .day-view .message {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #dcdcdc;
  padding: 5px 0px;
}
#chat-sticky .chat-content .chat-section .day-view .message .left-content h5 {
  font-size: 14px;
  margin-bottom: 5px;
}
#chat-sticky .chat-content .chat-section .day-view .message .left-content p {
  font-size: 12px;
}
#chat-sticky .chat-content .chat-section .day-view .message .right-content p {
  font-size: 10px;
}
#chat-sticky .chat-actions {
  padding: 0px 10px;
  box-sizing: border-box;
  height: 50px;
}
#chat-sticky .chat-actions form {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}
#chat-sticky .chat-actions form .left-action {
  width: 65%;
}
#chat-sticky .chat-actions form .left-action textarea {
  width: 100%;
  border: none;
  outline: none;
  border-bottom: 1px solid #dcdcdc;
}
#chat-sticky .chat-actions form .right-action button {
  min-width: 40px;
  line-height: 32px;
}
#chat-sticky .chat-actions form .right-action button:last-child {
  margin-left: 15px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/chat-sticky/chat-sticky.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,uBAAA;EACA,qHAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,sCAAA;EACA,aAAA;EACA,2BAAA;EACA,4BAAA;EACA,sBAAA;EACA,YAAA;AACJ;AACI;EACE,YAAA;AACN;AAEI;EACE,YAAA;AAAN;AAEM;EACE,eAAA;AAAR;AAKE;EACE,yBAAA;EACA,cAAA;AAHJ;AAKI;EACE,oDAAA;EACA,yBAAA;AAHN;AAMI;EACE,UAAA;EACA,yBAAA;AAJN;AAOI;EACE,yBAAA;AALN;AAQI;EACE,aAAA;AANN;AAQM;EACE,mBAAA;AANR;AASU;EACE,kBAAA;AAPZ;AAWQ;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;EACA,gBAAA;AATV;AAYY;EACE,eAAA;EACA,kBAAA;AAVd;AAaY;EACE,eAAA;AAXd;AAgBY;EACE,eAAA;AAdd;AAsBE;EACE,iBAAA;EACA,sBAAA;EACA,YAAA;AApBJ;AAsBI;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;AApBN;AAsBM;EACE,UAAA;AApBR;AAsBQ;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,gCAAA;AApBV;AA0BQ;EACE,eAAA;EACA,iBAAA;AAxBV;AA2BQ;EACE,iBAAA;AAzBV","sourcesContent":["#chat-sticky {\n  height: 100%;\n  background-color: white;\n  box-shadow: 0 8px 10px 1px rgba(0,0,0,0.14), 0 3px 14px 2px rgba(0,0,0,0.12), 0 5px 5px -3px rgba(0,0,0,0.2);\n\n  .chat-header {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    background-color: var(--primary-color);\n    padding: 10px;\n    border-top-left-radius: 4px;\n    border-top-right-radius: 4px;\n    box-sizing: border-box;\n    height: 40px;\n\n    h4 {\n      color: white;\n    }\n\n    mat-icon {\n      color: white;\n\n      &:hover {\n        cursor: pointer;\n      }\n    }\n  }\n\n  .chat-content {\n    height: calc(60vh - 90px);\n    overflow: auto;\n\n    &::-webkit-scrollbar-track {\n      -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);\n      background-color: #F5F5F5;\n    }\n\n    &::-webkit-scrollbar {\n      width: 6px;\n      background-color: #F5F5F5;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #404040;\n    }\n\n    .chat-section {\n      padding: 10px;\n\n      .day-view {\n        margin-bottom: 20px;\n\n        .date {\n          h6 {\n            text-align: center;\n          }\n        }\n\n        .message {\n          display: flex;\n          flex-direction: row;\n          justify-content: space-between;\n          align-items: flex-start;\n          border-bottom: 1px solid #dcdcdc;\n          padding: 5px 0px;\n\n          .left-content {\n            h5 {\n              font-size: 14px;\n              margin-bottom: 5px;\n            }\n\n            p {\n              font-size: 12px;\n            }\n          }\n\n          .right-content {\n            p {\n              font-size: 10px;\n            }\n          }\n        }\n      }\n    }\n  }\n\n  .chat-actions {\n    padding: 0px 10px;\n    box-sizing: border-box;\n    height: 50px;\n\n    form {\n      width: 100%;\n      height: 100%;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      align-items: center;\n\n      .left-action {\n        width: 65%;\n\n        textarea {\n          width: 100%;\n          border: none;\n          outline: none;\n          border-bottom: 1px solid #dcdcdc;\n        }\n      }\n\n      .right-action {\n\n        button {\n          min-width: 40px;\n          line-height: 32px;\n        }\n\n        button:last-child {\n          margin-left: 15px;\n        }\n      }\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
